import { ByLoggerTables } from '@bfe/by-logger';
import { getUrlObject, getQueryParams } from '@bfe/by-helpers';
import { getBrowser, getPlatformType } from '@bfe/by-browser-detector';
import ByPageView from './data-collector/byPageView';
import ByDataLayer from './data-collector/byDataLayer';
import BySignUp from './data-collector/bySignUp';
import LoggerObserver from './data-collector/loggerObserver';
import { urlCacheClosure, getPrimaryKey, getGaClientId, getReportUrl, getGuid, getTdId, setTdId, getUCache, getUid } from './utils';
var getUrlQuery = urlCacheClosure();
var reportUrl = getReportUrl();
/*
  规范：https://confluence.bybit.com/pages/viewpage.action?pageId=16782575
*/
// PageView埋点

var pageViewLogger = new LoggerObserver({
  logTable: ByLoggerTables.STORE_PV,
  keepAliveInBackground: true,
  noBackgroundTasks: true,
  reportInterval: -1,
  reportDelay: 2000,
  reportUrl: reportUrl,
  extendFields: true,
  getGuid: getGuid,
  getUid: getUid
}, {
  act: 'track_pageview',
  time: function time() {
    return new Date().getTime();
  },
  id: getPrimaryKey,
  // 唯一ID
  app_id: function app_id() {
    return window.APP_ID || 10000;
  },
  // u: , // UserId
  ga_id: getGaClientId,
  // app_version: ,
  p: getPlatformType,
  // page_name() {
  //   return document.title;
  // },
  // last_page_name: , 上一页面的标题名字
  url: function url() {
    return window.location.href;
  },
  referer: function referer() {
    return document.referrer;
  },
  screen_width: function screen_width() {
    return window.innerWidth;
  },
  screen_height: function screen_height() {
    return window.innerHeight;
  },
  medium: function medium() {
    return getUrlQuery().medium;
  },
  source: function source() {
    return getUrlQuery().source;
  },
  campaign: function campaign() {
    return getUrlQuery().campaign;
  },
  stage: function stage() {
    return getUrlQuery().stage;
  },
  content: function content() {
    return getUrlQuery().content;
  },
  term: function term() {
    return getUrlQuery().term;
  },
  lang: function lang() {
    return window.navigator.language;
  },
  net_t: function net_t() {
    var _window, _window$navigator, _window$navigator$con;

    return (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$con = _window$navigator.connection) === null || _window$navigator$con === void 0 ? void 0 : _window$navigator$con.effectiveType;
  },
  sys_mem: function sys_mem() {
    var _window2, _window2$performance, _window2$performance$;

    return (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$performance = _window2.performance) === null || _window2$performance === void 0 ? void 0 : (_window2$performance$ = _window2$performance.memory) === null || _window2$performance$ === void 0 ? void 0 : _window2$performance$.jsHeapSizeLimit;
  },
  resolution: function resolution() {
    return window.devicePixelRatio;
  },
  sys_cc: function sys_cc() {
    return window.navigator.hardwareConcurrency || 0;
  },
  f_java: function f_java() {
    var _window$navigator2, _window$navigator2$ja;

    return !!((_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : (_window$navigator2$ja = _window$navigator2.javaEnabled) === null || _window$navigator2$ja === void 0 ? void 0 : _window$navigator2$ja.call(_window$navigator2));
  },
  f_cookie: function f_cookie() {
    return !!window.navigator.cookieEnabled;
  },
  f_ls: function f_ls() {
    return !!window.localStorage;
  },
  f_ss: function f_ss() {
    return !!window.sessionStorage;
  },
  f_idb: function f_idb() {
    return !!window.indexedDB;
  },
  screen_aw: function screen_aw() {
    return window.screen.availWidth;
  },
  screen_ah: function screen_ah() {
    return window.screen.availHeight;
  },
  screen_cd: function screen_cd() {
    return window.screen.colorDepth;
  },
  webdriver: function webdriver() {
    return window.navigator.webdriver;
  },
  tz: function tz() {
    var _window3, _window3$Intl, _window3$Intl$DateTim, _window3$Intl$DateTim2, _window3$Intl$DateTim3;

    return (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$Intl = _window3.Intl) === null || _window3$Intl === void 0 ? void 0 : (_window3$Intl$DateTim = _window3$Intl.DateTimeFormat) === null || _window3$Intl$DateTim === void 0 ? void 0 : (_window3$Intl$DateTim2 = _window3$Intl$DateTim.call(_window3$Intl)) === null || _window3$Intl$DateTim2 === void 0 ? void 0 : (_window3$Intl$DateTim3 = _window3$Intl$DateTim2.resolvedOptions()) === null || _window3$Intl$DateTim3 === void 0 ? void 0 : _window3$Intl$DateTim3.timeZone;
  },
  plugins: function plugins() {
    var _window4, _window4$navigator;

    var plugins = ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$navigator = _window4.navigator) === null || _window4$navigator === void 0 ? void 0 : _window4$navigator.plugins) || [];
    var len = plugins.length; // Make sure only the first 3 plugin names to report,
    // but still report the origin length to save space.

    var reportLen = len <= 3 ? len : 3;
    var pluginNames = [];

    for (var i = 0; i < reportLen; i++) {
      // eslint-disable-line
      pluginNames.push(plugins[i].name);
    }

    return JSON.stringify({
      plugins: pluginNames,
      len: len
    });
  },
  browser: getBrowser,
  tdid: getTdId,
  u_cache: getUCache
});
var byPageView = new ByPageView();
byPageView.attachObserver(pageViewLogger);
/*
  规范：https://confluence.bybit.com/pages/viewpage.action?pageId=16782575
*/
// 代理GA埋点

var dataLayerLogger = new LoggerObserver({
  logTable: ByLoggerTables.STORE_EVENT,
  reportUrl: reportUrl,
  extendFields: true,
  keepAliveInBackground: true,
  noBackgroundTasks: true,
  getGuid: getGuid,
  getUid: getUid
}, {
  act: 'track_event',
  time: function time() {
    return new Date().getTime();
  },
  id: getPrimaryKey,
  // 唯一ID
  app_id: function app_id() {
    return window.APP_ID || 10000;
  },
  url: function url() {
    return window.location.href;
  },
  // u: , // UserId
  ga_id: getGaClientId,
  // app_version: ,
  p: getPlatformType,
  // duration: , // 单位毫秒，非必填
  lang: function lang() {
    return window.navigator.language;
  },
  browser: getBrowser,
  tdid: getTdId,
  u_cache: getUCache
});
var byDataLayer = new ByDataLayer();
byDataLayer.attachObserver(dataLayerLogger);
export var bySignUp = new BySignUp({
  logTable: ByLoggerTables.STORE_SIGNUP,
  reportUrl: reportUrl,
  extendFields: true,
  keepAliveInBackground: true,
  noBackgroundTasks: true,
  reportInterval: -1,
  reportDelay: 2000,
  getGuid: getGuid,
  getUid: getUid
}, {
  act: 'track_signup',
  time: function time() {
    return new Date().getTime();
  },
  id: getPrimaryKey,
  app_id: function app_id() {
    return window.APP_ID || 10000;
  },
  ga_id: getGaClientId,
  p: getPlatformType,
  url: function url() {
    return window.location.href;
  },
  referer: function referer() {
    return document.referrer;
  },
  medium: function medium() {
    return getUrlQuery().medium;
  },
  source: function source() {
    return getUrlQuery().source;
  },
  campaign: function campaign() {
    return getUrlQuery().campaign;
  },
  stage: function stage() {
    return getUrlQuery().stage;
  },
  content: function content() {
    return getUrlQuery().content;
  },
  term: function term() {
    return getUrlQuery().term;
  },
  su: function su() {
    var _getUrlQuery = getUrlQuery(),
        _getUrlQuery$su = _getUrlQuery.su,
        su = _getUrlQuery$su === void 0 ? '' : _getUrlQuery$su;

    if (su) return su;
    var referrerUrlObj = getUrlObject(document.referrer) || {};

    var _ref = getQueryParams(referrerUrlObj) || {},
        _ref$su = _ref.su,
        rsu = _ref$su === void 0 ? '' : _ref$su;

    return rsu;
  },
  lang: function lang() {
    return window.navigator.language;
  },
  tdid: getTdId,
  browser: getBrowser,
  u_cache: getUCache
});
/**
 * @function pushSignUp - Sign up only, Sendout data ,needs three params:
 * @param {object} opts - Options for customize options
 */

export var pushSignUp = function pushSignUp() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  bySignUp.update(opts);
};
var collector = {
  /**
   * Start listen and consume records
   * @param {object} initOpts init data fields on different type, like: pageview / event.
   */
  start: function start() {
    var initOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Preproces: Auto setup tdid and ucache
    setTdId(); // Init logger of pageview and datalayer

    var _initOpts$pageViewOpt = initOpts.pageViewOpts,
        pageViewOpts = _initOpts$pageViewOpt === void 0 ? {
      ignore: false
    } : _initOpts$pageViewOpt,
        _initOpts$dataLayerOp = initOpts.dataLayerOpts,
        dataLayerOpts = _initOpts$dataLayerOp === void 0 ? {} : _initOpts$dataLayerOp;

    if (!pageViewOpts.ignore) {
      byPageView.execute(pageViewOpts);
    }

    byDataLayer.execute(dataLayerOpts);
  }
};
export default collector;